(function () {
    var rules = (window.__GWP && window.__GWP.rules) || [];
    if (!rules.length) return;
    var R = window.routes || {};
    var busy = false;

    function getCart() { return fetch(R.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
    function post(url, body) { return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); }

    // --- Warenkorb-/Drawer-Anzeige nach dem Auto-Add sofort neu rendern (Dawn Section Rendering API) ---
    function refreshDrawer() {
        if (!document.querySelector('cart-drawer-items')) return Promise.resolve();
        return fetch(R.cart_url + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (txt) {
            var doc = new DOMParser().parseFromString(txt, 'text/html');
            ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
                var src = doc.querySelector(sel), dst = document.querySelector(sel);
                if (src && dst) dst.replaceWith(src);
            });
            var drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.classList.remove('is-empty');
        }).catch(function () { });
    }
    function refreshCartPage() {
        var el = document.querySelector('cart-items');
        if (!el) return Promise.resolve();
        return fetch(R.cart_url + '?section_id=main-cart-items').then(function (r) { return r.text(); }).then(function (txt) {
            var src = new DOMParser().parseFromString(txt, 'text/html').querySelector('cart-items');
            if (src) el.innerHTML = src.innerHTML;
        }).catch(function () { });
    }
    function refreshBubble() {
        var el = document.getElementById('cart-icon-bubble');
        if (!el) return Promise.resolve();
        return fetch(R.cart_url + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).then(function (txt) {
            var src = new DOMParser().parseFromString(txt, 'text/html').querySelector('.shopify-section');
            if (src) el.innerHTML = src.innerHTML;
        }).catch(function () { });
    }
    function refreshUI() { return Promise.all([refreshDrawer(), refreshCartPage(), refreshBubble()]); }

    function reconcile() {
        if (busy) return Promise.resolve();
        busy = true;
        var changed = false;
        return getCart().then(function (cart) {
            var items = cart.items || [];
            var chain = Promise.resolve();
            rules.forEach(function (rule) {
                var triggers = rule.trigger.map(String);
                // Trigger = Produkt-IDs (Regel aus Metaobjekt gwp_regel, Produktliste)
                var hasTrigger = items.some(function (i) { return triggers.indexOf(String(i.product_id)) !== -1; });
                var giftLine = items.find(function (i) { return String(i.variant_id) === String(rule.gift) && i.properties && i.properties._gwp; });
                var want = rule.qty || 1;
                if (hasTrigger && !giftLine) {
                    changed = true;
                    chain = chain.then(function () { return post(R.cart_add_url, { items: [{ id: rule.gift, quantity: want, properties: { _gwp: rule.label || '1' } }] }); });
                } else if (hasTrigger && giftLine && giftLine.quantity !== want) {
                    changed = true;
                    chain = chain.then(function () { return post(R.cart_change_url, { id: giftLine.key, quantity: want }); });
                } else if (!hasTrigger && giftLine) {
                    changed = true;
                    chain = chain.then(function () { return post(R.cart_change_url, { id: giftLine.key, quantity: 0 }); });
                }
            });
            return chain;
        }).then(function () {
            if (changed) return refreshUI();
        }).then(function () { busy = false; }).catch(function () { busy = false; });
    }

    // Cart-Mutationen abfangen (add/change/update) -> danach abgleichen. Eigene Ops via busy-Flag ausgeklammert.
    var _fetch = window.fetch;
    window.fetch = function () {
        var url = arguments[0] && arguments[0].url ? arguments[0].url : String(arguments[0]);
        var isCartMutation = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
        var p = _fetch.apply(this, arguments);
        if (isCartMutation && !busy) { p.then(function () { setTimeout(reconcile, 80); }); }
        return p;
    };
    document.addEventListener('DOMContentLoaded', reconcile);
})();
